import {ArrowLongLeftIcon, ArrowLongRightIcon} from '@heroicons/react/20/solid'
import React from "react";
import {useTranslation} from "react-i18next";

function Pagination({paginator, get, set}) {
	const {t} = useTranslation()
	const {currentPage, lastPage} = paginator;
	if (currentPage === 1 && lastPage === 1) {
		return <div className="mt-3"></div>
	}
	return (
		<nav className="mt-8 flex items-center justify-between px-4 sm:px-0">
			<div className="flex w-0 flex-1">
				<button
					disabled={currentPage === 1}
					onClick={e => {
						if (currentPage > 1) set(currentPage - 1)
						else set(1)
					}}
					className="group cursor-pointer select-none inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-full text-xs font-bold uppercase tracking-wider text-gray-600 hover:bg-gray-50 hover:border-cyan-300 hover:text-[#0b6a8c] transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-gray-200 disabled:hover:text-gray-600"
				>
					<ArrowLongLeftIcon className="rtl:hidden h-5 w-5 text-gray-400 group-hover:text-cyan-500 transition-colors" aria-hidden="true"/>
					<ArrowLongRightIcon className="ltr:hidden h-5 w-5 text-gray-400 group-hover:text-cyan-500 transition-colors" aria-hidden="true"/>
					{t('pagination.previous')}
				</button>
			</div>
			<div className="hidden md:flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-gray-400">
				<span>{t('pagination.page')}</span>
				<span className="text-[#0b6a8c] font-black">{currentPage}</span>
				<span className="mx-1">/</span>
				<span>{lastPage}</span>
			</div>
			<div className="flex w-0 flex-1 justify-end">
				<button
					disabled={currentPage === lastPage}
					onClick={e => {
						if (currentPage < lastPage) set(currentPage + 1)
						else set(currentPage)
					}}
					className="group cursor-pointer select-none inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-full text-xs font-bold uppercase tracking-wider text-gray-600 hover:bg-gray-50 hover:border-cyan-300 hover:text-[#0b6a8c] transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:border-gray-200 disabled:hover:text-gray-600"
				>
					{t('pagination.next')}
					<ArrowLongRightIcon className="rtl:hidden h-5 w-5 text-gray-400 group-hover:text-cyan-500 transition-colors" aria-hidden="true"/>
					<ArrowLongLeftIcon className="ltr:hidden h-5 w-5 text-gray-400 group-hover:text-cyan-500 transition-colors" aria-hidden="true"/>
				</button>
			</div>
		</nav>
	)
}

export default Pagination;